import React from 'react';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import { popoverClassName } from 'chameleon/ui-stack/ui/basic/simple-actions';
import { AccessibleMenuWithArrows } from 'chameleon/ui-stack/ui/assessments/actions/AccessibleMenuWithArrows';

export const FlyoutSecondMenu = ({
  children,
  trigger = () => {},
  fallBackPlacements = ['left-end', 'left-start'],
  position = 'left',
  className = '',
  isNarrow = false,
  size = 'normal',
}) => {
  return (
    <PopOver
      className={className}
      size={size}
      withPortal
      tabIndex={-1}
      position={position}
      contentClassName={popoverClassName}
      // this would ensure the popup would always stay on the left from the parent menu
      fallBackPlacements={fallBackPlacements}
      trigger={trigger}
      isNarrow={isNarrow}
    >
      <AccessibleMenuWithArrows>{children}</AccessibleMenuWithArrows>
    </PopOver>
  );
};
